<template>
  <div class="step-submitted d-flex flex-column align-center justify-center text-center pa-8 pa-md-12">
    <v-icon size="72" color="primary" class="mb-6">mdi-file-document-check-outline</v-icon>
    <h2 class="text-h5 font-weight-semibold mb-3 submitted-title">建站申请已提交，正在审核</h2>
    <p class="text-body-1 text-medium-emphasis mb-8 submitted-desc" style="max-width: 480px">
      请耐心等待审核结果，您可以通过右上角"我的电站"查看进度。如需补充材料，平台将通过预留联系方式与您沟通。
    </p>
    <v-btn color="primary" variant="flat" rounded="lg" min-width="200" @click="$emit('done')">返回电站列表</v-btn>
  </div>
</template>

<script setup>
defineEmits(['done'])
</script>

<style scoped lang="scss">
.step-submitted {
  min-height: 360px;
}

.submitted-title {
  color: var(--color-text);
  letter-spacing: -0.02em;
}
</style>
